import Header from "./component/Header";
import Footer from "./component/Footer";
import Main from "./component/Main";
import Section from "./component/Section";
import TitleSection from "./component/TitleSection";
import AboutSection from "./component/AboutSection";
import LoNeSection from "./component/LoNeSection";
import ContactSection from "./component/ContactSection";

function App() {
  return (
    <div>
      <Header />
      <Main>
        <Section name="home">
          <TitleSection />
        </Section>
        <Section name="about">
          <AboutSection />
        </Section>
        <Section name="lone">
          <LoNeSection />
        </Section>
        <Section name="contact">
          <ContactSection />
        </Section>
      </Main>
      <Footer />
    </div>
  );
}

export default App;
